module.exports = __webpack_public_path__ + "img/bamboo-bg.7d54137d.jpg";